module.exports = __webpack_public_path__ + "img/9788992844376.ebb2f782.jpg";